import toURL from '@homeaway/search-url-parser/dist/transpiled/toURL';
import Cookies from 'js-cookie';

import {
  SEARCH_COOKIE
} from '../../config/constants';

export const buildPropertyTypeSerpUrl = ({ destination, propertyTypeSerpFilter }) => {
  const cookie = Cookies.getJSON(SEARCH_COOKIE) || {
    arrival: '',
    departure: ''
  };

  const {
    arrival,
    departure
  } = cookie;

  return toURL({
    arrival,
    departure,
    filter: propertyTypeSerpFilter,
    q: destination
  });
};

export const getSubtitle = (subtitleTemplate, formattedCount, propertyTypePlural) =>
  subtitleTemplate
    .replace('{listingCount}', formattedCount)
    .replace('{propertyType}', propertyTypePlural);
